module.exports = "<button class=\"btn btn-default\" (click)=\"showDialog()\">{{title}}</button>"


//////////////////
// WEBPACK FOOTER
// C:/_/Platform1/Paragon/Application/Common/UI.RenderEngine/src/app/components/pg-renderer/item-body/item-body-panel/ipp/ipp-writing-sample-response/ipp-writing-sample-response.component.html
// module id = Wzg8
// module chunks = 1